import { fiberHexStd, splOutputs } from "./spliceUtils";

export function SpliceSplitters({ splitters, splX, splInY, splOutY, splPortOcc, armedSpl, clickSplitterPort, settings, cables }) {
  const cbl = (id) => (cables || []).find((c) => c.id === id);
  return splitters.map((s, i) => {
    const x = splX(i);
    const outs = splOutputs(s);
    return (
      <g key={s.id} data-testid={`splitter-${s.id}`}>
        <rect x={x - 26} y={58} width="52" height={splOutY(outs) - 48} rx="4" fill="#1e293b" stroke="#f97316" strokeWidth="1" />
        <text x={x} y={54} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fdba74">{s.number} ({s.split_type})</text>
        {(() => {
          const inOcc = splPortOcc[`${s.id}-in-0`];
          const tgt = armedSpl && armedSpl.id !== s.id;
          return (
            <g onClick={() => clickSplitterPort(s, "in", 0)} style={{ cursor: "pointer" }} data-testid={`spl-in-${s.id}`}>
              <circle cx={x} cy={splInY} r="5.5" fill={inOcc ? fiberHexStd(settings, cbl(inOcc.cable_id), inOcc.fiber_in) : "#f97316"} stroke={tgt ? "#22d3ee" : "#fed7aa"} strokeWidth={tgt ? 2.4 : 1.2} />
              <text x={x} y={splInY + 3} textAnchor="middle" fontSize="6" fill="#0b1120">WE</text>
            </g>
          );
        })()}
        {Array.from({ length: outs }, (_, k) => k + 1).map((p) => {
          const pOcc = splPortOcc[`${s.id}-out-${p}`];
          const isArmedOut = armedSpl && armedSpl.id === s.id && armedSpl.port === p;
          return (
            <g key={p} onClick={() => clickSplitterPort(s, "out", p)} style={{ cursor: "pointer" }} data-testid={`spl-out-${s.id}-${p}`}>
              <circle cx={x} cy={splOutY(p)} r="4.5" fill={pOcc ? (pOcc.cascade ? "#f97316" : pOcc.client ? "#ef4444" : fiberHexStd(settings, cbl(pOcc.cable_id), pOcc.fiber_in)) : "#0b1120"} stroke={isArmedOut ? "#22d3ee" : "#f97316"} strokeWidth={isArmedOut || pOcc ? 2.4 : 1.2} />
              <text x={x + 9} y={splOutY(p) + 3} fontSize="7" fill={pOcc ? "#fdba74" : "#94a3b8"}>{p}{pOcc?.client ? ` · ${(pOcc.clientName || "").slice(0, 12)}` : ""}</text>
            </g>
          );
        })}
      </g>
    );
  });
}
